import React, { useState, useEffect } from 'react';
import { Layout, Button, Breadcrumb, Badge, Card, Spin, Typography, Icon, Divider, Tag, Select, message, Modal } from 'antd';
import { FaDesktop, FaDownload } from 'react-icons/fa';
import axios from 'axios';
import { config, general } from '../../../../../constants'
const { Header, Content, Sider } = Layout;
const { Title, Text, Paragraph } = Typography;
const { Option } = Select;

const SOPModal = ({ docEditorFile, data = {}, userId, userName, orgId, shlToken, refreshToken, setEditor, isDHL }) => {

  const doc = docEditorFile || (data && data.data) || {};
  console.log("Doc doc", doc)
  const [showMap, setShowMap] = useState(false);

  // State for selected documents in each category
  const [selectedGlobalSOP, setSelectedGlobalSOP] = useState([]);
  const [selectedBPSpecific, setSelectedBPSpecific] = useState([]);
  const [selectedAnnexures, setSelectedAnnexures] = useState([]);
  const [selectedWorkInstructions, setSelectedWorkInstructions] = useState([]);
  const [selectedSOWParent, setSelectedSOWParent] = useState([]);

  const [selectedMergeDocument, setSelectedMergeDocument] = useState(null);
  const [mergeLoading, setMergeLoading] = useState(false);

  // State for ALL items (selected + available)
  const [allGlobalSOPItems, setAllGlobalSOPItems] = useState([]);
  const [allBPItems, setAllBPItems] = useState([]);
  const [allAnnexuresItems, setAllAnnexuresItems] = useState([]);
  const [allWorkInstructionsItems, setAllWorkInstructionsItems] = useState([]);
  const [allSOWParentItems, setAllSOWParentItems] = useState([]);

  // State for document data
  const [documentData, setDocumentData] = useState(null);
  const [loading, setLoading] = useState(true);

  // State for document type data
  const [documentTypeData, setDocumentTypeData] = useState(null);
  const [documentTypeLoading, setDocumentTypeLoading] = useState(false);

  // State for expanded panels
  const [isGlobalSOPExpanded, setIsGlobalSOPExpanded] = useState(true);
  const [isBPExpanded, setIsBPExpanded] = useState(true);
  const [isAnnexuresExpanded, setIsAnnexuresExpanded] = useState(true);
  const [isWorkInstructionsExpanded, setIsWorkInstructionsExpanded] = useState(true);
  const [isSOWParentExpanded, setIsSOWParentExpanded] = useState(true);

  // Helper function to build API URL with optional /dhl/
  const buildApiUrl = (baseUrl) => {
    if (isDHL) {
      return baseUrl.replace('sop-management/', 'sop-management/dhl/');
    }
    return baseUrl;
  };

  // Fetch document type if docEditorFile exists and has an ID
  useEffect(() => {
    const fetchDocumentType = async () => {
      if (docEditorFile && docEditorFile.id) {
        setDocumentTypeLoading(true);
        try {
          const url = `${config.aiContentGenerationUrl}sop-management/media/${docEditorFile.id}/document-type?org_id=${orgId}`;
          const response = await axios.get(url, {
            headers: {
              'Authorization': `Bearer ${shlToken}`
            }
          });
          setDocumentTypeData(response.data);
          console.log("Document type data:", response.data);
        } catch (error) {
          console.error("Error fetching document type:", error);
          message.error("Failed to fetch document type");
        } finally {
          setDocumentTypeLoading(false);
        }
      }
    };

    fetchDocumentType();
  }, [docEditorFile, orgId, shlToken, isDHL]);

  // Fetch relationships data
  useEffect(() => {
    if (!doc || !doc.id || !orgId) {
      setLoading(false);
      return;
    }

    const fetchRelationships = async () => {
      try {
        setLoading(true);
        const url = buildApiUrl(`${config.aiContentGenerationUrl}sop-management/media/${doc.id}/relationships?org_id=${orgId}`);
        const response = await axios.get(url, {
          headers: {
            Authorization: 'Bearer ' + shlToken
          }
        });

        const responseData = response.data;
        console.log("responseData: ", responseData);

        // Set document data
        if (responseData && responseData.document) {
          setDocumentData(responseData.document);
        }

        // Preselected relationships
        if (responseData && responseData.relationships) {
          // Global SOP
          if (Array.isArray(responseData.relationships.global_sop)) {
            const ids = responseData.relationships.global_sop.map(function (item) { return item.id; });
            setSelectedGlobalSOP(ids);
            setAllGlobalSOPItems(responseData.relationships.global_sop);
          }

          // BP-Specific
          if (Array.isArray(responseData.relationships.referenced_by)) {
            const ids = responseData.relationships.referenced_by.map(function (item) { return item.id; });
            setSelectedBPSpecific(ids);
            setAllBPItems(responseData.relationships.referenced_by);
          }

          // Annexures
          if (Array.isArray(responseData.relationships.annexures)) {
            const ids = responseData.relationships.annexures.map(function (item) { return item.id; });
            setSelectedAnnexures(ids);
            setAllAnnexuresItems(responseData.relationships.annexures);
          }

          // Work Instructions - CORRECTED: work_instruction (singular)
          if (Array.isArray(responseData.relationships.work_instruction)) {
            const ids = responseData.relationships.work_instruction.map(function (item) { return item.id; });
            setSelectedWorkInstructions(ids);
            setAllWorkInstructionsItems(responseData.relationships.work_instruction);
          }

          // SOW Parent
          if (Array.isArray(responseData.relationships.parents)) {
            const ids = responseData.relationships.parents.map(function (item) { return item.id; });
            setSelectedSOWParent(ids);
            setAllSOWParentItems(responseData.relationships.parents);
          }
        }

        // Available lists - merge with existing items
        if (responseData && responseData.available) {
          if (Array.isArray(responseData.available.global_sop)) {
            const existing = (responseData.relationships && responseData.relationships.global_sop) || [];
            const merged = mergeUniqueItems(existing, responseData.available.global_sop);
            setAllGlobalSOPItems(merged);
          }

          if (Array.isArray(responseData.available.referenced_by)) {
            const existing = (responseData.relationships && responseData.relationships.referenced_by) || [];
            const merged = mergeUniqueItems(existing, responseData.available.referenced_by);
            setAllBPItems(merged);
          }

          if (Array.isArray(responseData.available.annexures)) {
            const existing = (responseData.relationships && responseData.relationships.annexures) || [];
            const merged = mergeUniqueItems(existing, responseData.available.annexures);
            setAllAnnexuresItems(merged);
          }

          // Work Instructions - CORRECTED: work_instruction (singular)
          if (Array.isArray(responseData.available.work_instruction)) {
            const existing = (responseData.relationships && responseData.relationships.work_instruction) || [];
            const merged = mergeUniqueItems(existing, responseData.available.work_instruction);
            setAllWorkInstructionsItems(merged);
          }

          if (Array.isArray(responseData.available.parents)) {
            const existing = (responseData.relationships && responseData.relationships.parents) || [];
            const merged = mergeUniqueItems(existing, responseData.available.parents);
            setAllSOWParentItems(merged);
          }
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching relationships:", error);
        message.error("Failed to load relationships data");
        setLoading(false);
      }
    };

    fetchRelationships();
  }, [doc.id, orgId, shlToken, isDHL]);

  // Helper function to merge arrays without duplicates
  const mergeUniqueItems = (arr1, arr2) => {
    const combined = [...arr1, ...arr2];
    const unique = [];
    const seenIds = {};

    for (let i = 0; i < combined.length; i++) {
      const item = combined[i];
      if (item && item.id && !seenIds[item.id]) {
        seenIds[item.id] = true;
        unique.push(item);
      }
    }

    return unique;
  };

  // Handle POST request when user selects an item
  const handleRelationshipAdd = async (selectedId, relationshipType) => {
    try {
      const targetMediaId = documentData && documentData.id ? documentData.id : (doc && doc.id ? doc.id : null);

      if (!targetMediaId) {
        message.error('Document ID not found');
        return;
      }

      const postData = {
        source_media_id: targetMediaId,
        target_media_id: selectedId,
        relationship_type: relationshipType,
        description: 'add ' + relationshipType
      };

      const url = buildApiUrl(`${config.aiContentGenerationUrl}sop-management/relationships?org_id=${orgId}`);
      await axios.post(url, postData, {
        headers: {
          'Authorization': 'Bearer ' + shlToken,
          'Content-Type': 'application/json'
        }
      });

      message.success('Document Relation added successfully');
    } catch (error) {
      console.error('Error adding relationship:', error);
      message.error('Failed to add relationship');
    }
  };

  // Handle POST request for adding parent
  const handleParentAdd = async (selectedId) => {
    try {
      const targetMediaId = documentData && documentData.id ? documentData.id : (doc && doc.id ? doc.id : null);

      if (!targetMediaId) {
        message.error('Document ID not found');
        return;
      }

      const url = buildApiUrl(`${config.aiContentGenerationUrl}sop-management/media/${targetMediaId}/add-parent?org_id=${orgId}`);
      await axios.post(url, {
        parent_media_id: selectedId
      }, {
        headers: {
          'Authorization': 'Bearer ' + shlToken,
          'Content-Type': 'application/json'
        }
      });

      message.success('SOW document added successfully');
    } catch (error) {
      console.error('Error adding parent:', error);
      message.error('Failed to add SOW document');
    }
  };

  const getDocTypeColor = (type) => {
    const normalizedType = type && type.trim ? type.trim() : '';
    switch (normalizedType) {
      case 'Global Statement of Work': return 'orange';
      case 'Global SOP - Key Stroke': return 'blue';
      case 'BP-Specific SOP - Key Stroke': return 'purple';
      case 'Annexures': return 'green';
      case 'Work Instructions': return 'purple';
      case 'Workflow': return 'cyan';
      case 'General': return 'geekblue';
      default: return 'default';
    }
  };

  const getDocTypeIcon = (type) => {
    const normalizedType = type && type.trim ? type.trim() : '';
    switch (normalizedType) {
      case 'Global Statement of Work': return 'file';
      case 'Global SOP - Key Stroke': return 'global';
      case 'BP-Specific SOP - Key Stroke': return 'gold';
      case 'Annexures': return 'paper-clip';
      case 'Work Instructions': return 'gold';
      case 'Workflow': return 'branches';
      case 'General Document': return 'file-text';
      default: return 'file-text';
    }
  };

  const handleEditInApp = async () => {
    const base_Url = config.baseURL.replace(/\/v1\/?$/, '')
    const ai_Url = config.questionAnswerAiUrl || config.aiContentGenerationUrl

    console.log('refreshToken log', refreshToken)
    console.log("shlToken:", shlToken);
    console.log("orgId:", orgId);
    console.log("refreshToken:", refreshToken);
    console.log("base_Url:", base_Url);
    console.log("ai_Url:", ai_Url);
    console.log("userId:", userId);
    console.log("docEditorFile:", docEditorFile);
    console.log("data.data:", data && data.data);

    // Get custom_data - check docEditorFile first, then data.data
    const customData = (docEditorFile && docEditorFile.custom_data) || (data && data.data && data.data.custom_data) || '';
    const media_id = (docEditorFile && docEditorFile.id) || (data && data.data && data.data.id) || '';
    const customDataParam = customData ? `&project_data=${encodeURIComponent(JSON.stringify(customData))}` : '';

    const deepLink = `sharelookapp://open?token=${shlToken}&org_id=${orgId}&refreshToken=${refreshToken}&base_Url=${base_Url}&ai_Url=${ai_Url}&userId=${userId}&template_id=7${customDataParam}&media_id=${media_id}`;

    console.log("Generated Deep Link:", deepLink);

    showLaunchConfirmation(deepLink)
  }

  const showLaunchConfirmation = deepLink => {
    const modal = Modal.confirm({
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FaDesktop style={{ marginRight: '8px', color: '#1890ff' }} />
          Launch ShareLook Application
        </div>
      ),
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            This will open the ShareLook application for screen capture
          </p>
          <p style={{ color: '#666', fontSize: '14px', marginBottom: '0' }}>
            If ShareLook doesn't open, you may need to download it first
          </p>
        </div>
      ),
      okText: (
        <span>
          <FaDesktop style={{ marginRight: '6px' }} />
          Open ShareLook
        </span>
      ),
      cancelText: 'Cancel',
      okType: 'primary',
      width: 450,
      onOk: () => {
        attemptAppLaunch(deepLink)
      },
      onCancel: () => {
        console.log('User cancelled app launch')
      },
      footer: (_, { OkBtn, CancelBtn }) => (
        <div style={{ textAlign: 'center' }}>
          <CancelBtn />
          <OkBtn />
          <Button
            type="default"
            onClick={() => {
              window.open(
                'https://mj-scorm-bucket.s3.us-east-1.amazonaws.com/windows-screen-capture-app/ELearningSetup.exe',
                '_blank'
              )
              modal.destroy()
            }}
            style={{ marginLeft: '8px' }}
          >
            <FaDownload style={{ marginRight: '6px' }} />
            Download App
          </Button>
        </div>
      )
    })
  }

  const showAppNotFound = () => {
    Modal.warning({
      title: 'ShareLook Not Found',
      content: (
        <div>
          <p>The ShareLook application doesn't appear to be installed.</p>
          <p>Would you like to download it?</p>
        </div>
      ),
      okText: 'Download ShareLook',
      onOk: () => {
        window.open(
          'https://mj-scorm-bucket.s3.us-east-1.amazonaws.com/windows-screen-capture-app/ELearningSetup.exe',
          '_blank'
        )
      }
    })
  }

  const attemptAppLaunch = deepLink => {
    console.log('Attempting to launch ShareLook with deepLink:', deepLink)

    const hide = message.loading('Opening ShareLook...', 2)

    let appLaunched = false

    const detectAppLaunch = () => {
      const onBlur = () => {
        appLaunched = true
        cleanup()
        hide()
        message.success('ShareLook opened successfully')
      }

      const onVisibilityChange = () => {
        if (document.hidden) {
          appLaunched = true
          cleanup()
          hide()
          message.success('ShareLook opened successfully')
        }
      }

      const cleanup = () => {
        window.removeEventListener('blur', onBlur)
        document.removeEventListener('visibilitychange', onVisibilityChange)
      }

      window.addEventListener('blur', onBlur)
      document.addEventListener('visibilitychange', onVisibilityChange)

      setTimeout(() => {
        cleanup()
        hide()
        if (!appLaunched) {
          showAppNotFound()
        }
      }, 3000)
    }

    try {
      detectAppLaunch()
      window.location.href = deepLink
    } catch (error) {
      console.error('Direct launch failed, trying fallback:', error)

      try {
        const link = document.createElement('a')
        link.href = deepLink
        link.target = '_self'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (fallbackError) {
        console.error('All launch methods failed:', fallbackError)
        hide()
        showAppNotFound()
      }
    }
  }

  const openInCODEEditor = () => {
    setEditor({
      editorParams: {
        documentName: '',
        documentId: '',
        userId: '',
        userName: ''
      },
      isShowEditor: true
    });
    setShowMap(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const handleRemoveTag = async (category, id) => {
    try {
      const sourceMediaId = documentData && documentData.id ? documentData.id : (doc && doc.id ? doc.id : null);

      if (!sourceMediaId) {
        message.error('Document ID not found');
        return;
      }

      // Determine if we need to swap the IDs based on document type
      const shouldSwap = isChildDocument();

      const url = buildApiUrl(`${config.aiContentGenerationUrl}sop-management/remove-relationships`);
      await axios.delete(url, {
        params: {
          source_media_id: shouldSwap ? id : sourceMediaId,
          target_media_id: shouldSwap ? sourceMediaId : id,
          org_id: orgId
        },
        headers: {
          Authorization: 'Bearer ' + shlToken
        }
      });

      // Update state after successful deletion
      switch (category) {
        case 'globalSOP':
          setSelectedGlobalSOP(selectedGlobalSOP.filter(function (i) { return i !== id; }));
          break;
        case 'bpSpecific':
          setSelectedBPSpecific(selectedBPSpecific.filter(function (i) { return i !== id; }));
          break;
        case 'annexures':
          setSelectedAnnexures(selectedAnnexures.filter(function (i) { return i !== id; }));
          break;
        case 'workInstructions':
          setSelectedWorkInstructions(selectedWorkInstructions.filter(function (i) { return i !== id; }));
          break;
        case 'sowParent':
          setSelectedSOWParent(selectedSOWParent.filter(function (i) { return i !== id; }));
          break;
        default:
          break;
      }

      message.success('Document Relation removed successfully');
    } catch (error) {
      console.error('Error removing relationship:', error);
      message.error('Failed to remove relationship');
    }
  };

  // Handle selection changes
  const handleGlobalSOPChange = (values) => {
    const newValues = values.filter(function (v) { return !selectedGlobalSOP.includes(v); });
    if (newValues.length > 0) {
      const newId = newValues[0];
      handleRelationshipAdd(newId, 'global_sop');
    }
    setSelectedGlobalSOP(values);
  };

  // Handle BP-Specific selection change
  const handleBPSpecificChange = (values) => {
    const newValues = values.filter(function (v) { return !selectedBPSpecific.includes(v); });
    if (newValues.length > 0) {
      const newId = newValues[0];
      handleRelationshipAdd(newId, 'reference');
    }
    setSelectedBPSpecific(values);
  };

  const handleAnnexuresChange = (values) => {
    const newValues = values.filter(function (v) { return !selectedAnnexures.includes(v); });
    if (newValues.length > 0) {
      const newId = newValues[0];
      handleRelationshipAdd(newId, 'annexures');
    }
    setSelectedAnnexures(values);
  };

  const handleWorkInstructionsChange = (values) => {
    const newValues = values.filter(function (v) { return !selectedWorkInstructions.includes(v); });
    if (newValues.length > 0) {
      const newId = newValues[0];
      handleRelationshipAdd(newId, 'work_instructions');
    }
    setSelectedWorkInstructions(values);
  };

  const handleSOWParentChange = (values) => {
    const newValues = values.filter(function (v) { return !selectedSOWParent.includes(v); });
    if (newValues.length > 0) {
      const newId = newValues[0];
      handleParentAdd(newId);
    }
    setSelectedSOWParent(values);
  };

  // Get item by ID
  const getGlobalSOPItemById = (id) => {
    return allGlobalSOPItems.find(function (item) { return item.id === id; });
  };

  const getBPItemById = (id) => {
    return allBPItems.find(function (item) { return item.id === id; });
  };

  const getAnnexuresItemById = (id) => {
    return allAnnexuresItems.find(function (item) { return item.id === id; });
  };

  const getWorkInstructionsItemById = (id) => {
    return allWorkInstructionsItems.find(function (item) { return item.id === id; });
  };

  const getSOWParentItemById = (id) => {
    return allSOWParentItems.find(function (item) { return item.id === id; });
  };

  // Panel component for document categories
  const DocumentPanel = (props) => {
    const title = props.title;
    const icon = props.icon;
    const iconColor = props.iconColor;
    const isExpanded = props.isExpanded;
    const setIsExpanded = props.setIsExpanded;
    const selectedItems = props.selectedItems;
    const handleChange = props.handleChange;
    const availableData = props.availableData;
    const category = props.category;
    const tagColor = props.tagColor;
    const getItemById = props.getItemById;
    const loading = props.loading;

    return (
      <div style={{ marginBottom: 16, border: '1px solid #d9d9d9', borderRadius: 4, overflow: 'hidden' }}>
        <div
          onClick={function () { setIsExpanded(!isExpanded); }}
          style={{
            padding: '12px 16px',
            background: '#fafafa',
            borderBottom: isExpanded ? '1px solid #d9d9d9' : 'none',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            transition: 'all 0.3s'
          }}
        >
          <span>
            <Icon type={icon} style={{ color: iconColor, marginRight: 8 }} />
            <Text strong style={{ fontSize: 12 }}>{title}</Text>
          </span>
          <span>
            {selectedItems.length > 0 && (
              <Badge count={selectedItems.length} style={{ backgroundColor: iconColor, marginRight: 8 }} />
            )}
            <Icon
              type={isExpanded ? "up" : "down"}
              style={{ fontSize: 12, color: '#8c8c8c' }}
            />
          </span>
        </div>
        {isExpanded && (
          <div style={{
            padding: 16,
            background: '#fff',
            animation: 'slideDown 0.3s ease-out'
          }}>
            <Select
              mode="multiple"
              style={{ width: '100%', marginBottom: 12 }}
              placeholder="Select documents"
              value={selectedItems}
              onChange={handleChange}
              allowClear
              maxTagCount={0}
              maxTagPlaceholder={selectedItems.length + ' selected'}
              getPopupContainer={function (trigger) { return trigger.parentNode; }}
              loading={loading}
              showSearch
              optionFilterProp="label"
            >
              {availableData.map(function (item) {
                var displayText = item.title || item.filename;
                return (
                  <Option key={item.id} value={item.id} label={displayText}>
                    <span style={{ fontSize: 11 }}>
                      {displayText}
                    </span>
                  </Option>
                );
              })}
            </Select>
            {selectedItems.length > 0 && (
              <div>
                {selectedItems.map(function (id) {
                  const item = getItemById(id);
                  return item ? (
                    <Tag
                      key={id}
                      closable
                      color={tagColor}
                      onClose={function () { handleRemoveTag(category, id); }}
                      style={{ marginBottom: 8, marginRight: 8, fontSize: 11, display: 'inline-block', cursor: 'pointer' }}
                      onClick={function () {
                        setEditor({
                          editorParams: {
                            documentName: item.title,
                            documentId: item.path,
                            userId: userId,
                            userName: userName
                          },
                          isShowEditor: true
                        });
                        setShowMap(false);
                      }}
                    >
                      {item.title || item.filename}
                    </Tag>
                  ) : null;
                })}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Check if current document is SOW (parent) - show all children
  const isSOWDocument = () => {
    const currentDocType = documentData?.document_type_name || doc?.document_type_name;
    return currentDocType === "Global Statement of Work";
  };

  // Check if current document is a child - show parent (SOW)
  const isChildDocument = () => {
    const currentDocType = documentData?.document_type_name || doc?.document_type_name;
    return (
      currentDocType === "Global SOP - Key Stroke" ||
      currentDocType === "BP-Specific SOP - Key Stroke" ||
      currentDocType === "Annexures" ||
      currentDocType === "Work Instructions"
    );
  };

  const handleWorkInstructionSelect = (value) => {
    setSelectedMergeDocument(value);
  };

  // Add this handler function for merge
  const handleMergeDocument = async () => {
    if (!selectedMergeDocument) {
      message.error('Please select a document to merge');
      return;
    }
    setMergeLoading(true);
    try {
      // Get parent document path
      const parentUrl = `${config.aiContentGenerationUrl}sop-management/media/${doc.id}/document-type?org_id=${orgId}`;
      const parentResponse = await axios.get(parentUrl, {
        headers: {
          'Authorization': `Bearer ${shlToken}`
        }
      });

      const parentPath = parentResponse?.data?.data.path;
      console.log("parentPath", parentPath)
      console.log("orgId", orgId)
      console.log("userId", userId)
      // Get selected document path
      const selectedItem = getWorkInstructionsItemById(selectedMergeDocument);
      console.log("selectedItem.path", selectedItem.path)
      if (!selectedItem || !selectedItem.path) {
        message.error('Selected document path not found');
        setMergeLoading(false);
        return;
      }

      // Call merge API
      const mergeUrl = 'https://shl-ai.dev.sharelookapp.link?service=work-instructions';
      await axios.post(mergeUrl, {
        parent_doc: parentPath,
        org_id: orgId,
        user_id: userId,
        work_instruction_key: selectedItem.path
      }, {
        headers: {
          'Authorization': `Bearer ${shlToken}`,
          'Content-Type': 'application/json'
        }
      });

      message.success('Document merged successfully');
      setSelectedMergeDocument(null);
    } catch (error) {
      console.error('Error merging document:', error);
      message.error('Failed to merge document');
    } finally {
      setMergeLoading(false);
    }
  };

  return (
    <Layout style={{ height: '100vh' }}>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 24px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Icon type="home" />
            </Breadcrumb.Item>
            <Breadcrumb.Item>SOP Documents</Breadcrumb.Item>
            <Breadcrumb.Item>{doc.title || 'Document'}</Breadcrumb.Item>
          </Breadcrumb>
        </Header>
        {documentTypeLoading ? (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'calc(100vh - 64px)',
            background: '#f5f5f5'
          }}>
            <Spin size="large" />
          </div>
        ) : (
          <>
            <div style={{ background: '#fff', padding: '12px 24px', borderBottom: '1px solid #f0f0f0' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <Tag color={getDocTypeColor(documentData && documentData.document_type_name || doc.document_type_name)}>
                  <Icon type={getDocTypeIcon(documentData && documentData.document_type_name || doc.document_type_name)} /> {(documentData && documentData.document_type_name || doc.document_type_name || 'Unknown Type')
                    .charAt(0).toUpperCase() +
                    (documentData && documentData.document_type_name || doc.document_type_name || 'Unknown Type')
                      .slice(1)
                  }
                </Tag>
                <Text type="secondary">
                  Creator: <strong>{doc.creator_id === userId ? userName : (doc.creator_id || 'N/A')}</strong>
                </Text>
                <Text type="secondary">Created: <strong>{formatDate(doc.created_at)}</strong></Text>
              </div>
            </div>
            <Content style={{ padding: 24, overflow: 'auto', background: '#f5f5f5' }}>
              {showMap ? (
                <Card>
                  <Title level={4}>Document Relationship Map</Title>
                  <div style={{ border: '2px solid #f0f0f0', borderRadius: 8, padding: 40, background: 'linear-gradient(135deg, #fafafa 0%, #e6f7ff 100%)' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Card
                        style={{
                          maxWidth: 550,
                          background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                          border: '4px solid #0050b3',
                          textAlign: 'center',
                          marginBottom: 16
                        }}
                      >
                        <div>
                          <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: 11 }}>CURRENT DOCUMENT</Text>
                          <div style={{ margin: '8px 0' }}>
                            <Icon type={getDocTypeIcon(documentData && documentData.document_type_name || doc.document_type_name)} style={{ color: '#fff', marginRight: 8 }} />
                            <Text strong style={{ fontSize: 16, color: '#fff' }}>{doc.title || 'Document'}</Text>
                          </div>
                          <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: 11 }}>{documentData && documentData.document_type_name || doc.document_type_name || 'Unknown Type'}</Text>
                        </div>
                      </Card>
                      <div style={{ textAlign: 'center', padding: 40, color: '#8c8c8c' }}>
                        <Icon type="info-circle" style={{ fontSize: 32, marginBottom: 16 }} />
                        <Text type="secondary">No relationship data available</Text>
                      </div>
                    </div>
                  </div>
                  <Divider />
                  <Card size="small" style={{ background: '#fafafa' }}>
                    <Title level={5}>Document Type Legend:</Title>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                      <div><Icon type="file" style={{ color: '#fa8c16', marginRight: 8 }} /> <Text>Global Statement of Work</Text></div>
                      <div><Icon type="global" style={{ color: '#1890ff', marginRight: 8 }} /> <Text>Global SOP - Key Stroke</Text></div>
                      <div><Icon type="gold" style={{ color: '#722ed1', marginRight: 8 }} /> <Text>BP-Specific SOP - Key Stroke</Text></div>
                      <div><Icon type="paper-clip" style={{ color: '#52c41a', marginRight: 8 }} /> <Text>Annexures</Text></div>
                      <div><Icon type="gold" style={{ color: '#722ed1', marginRight: 8 }} /> <Text>Work Instructions</Text></div>
                    </div>
                  </Card>
                </Card>
              ) : (
                <Card>
                  <div style={{
                    background: 'linear-gradient(135deg, #f0f5ff 0%, #e6f7ff 50%, #f9f0ff 100%)',
                    padding: '32px',
                    borderRadius: '12px',
                    border: '1px solid #d9d9d9'
                  }}>
                    <Title level={3} style={{ color: '#262626', marginBottom: '32px', fontWeight: 600 }}>
                      {doc.title || 'Document'}
                    </Title>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      gap: '32px'
                    }}>
                      <div style={{
                        flex: 1,
                        borderRadius: '16px',
                        padding: '40px 32px',
                        textAlign: 'center',
                        background: '#fff',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <div>
                          <Icon type="file-word" style={{ fontSize: 64, color: '#1890ff', marginBottom: 12 }} />
                          <div><Text style={{ color: '#8c8c8c', fontSize: '14px' }}>{doc.title || 'Document'}</Text></div>
                          {doc.file_size && (
                            <div><Text type="secondary" style={{ fontSize: '12px' }}>Size: {doc.file_size} bytes</Text></div>
                          )}
                        </div>
                      </div>
                      <div style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px'
                      }}>
                        <Button
                          type="primary"
                          size="large"
                          block
                          icon="edit"
                          style={{
                            height: '56px',
                            fontSize: '16px',
                            background: '#1890ff',
                            borderColor: '#1890ff',
                            fontWeight: 500,
                            boxShadow: '0 2px 8px rgba(24,144,255,0.3)'
                          }}
                          onClick={openInCODEEditor}
                        >
                          Open In Editor
                        </Button>
                        <Button
                          type="primary"
                          size="large"
                          block
                          icon="edit"
                          style={{
                            height: '56px',
                            fontSize: '16px',
                            background: '#1890ff',
                            borderColor: '#1890ff',
                            fontWeight: 500,
                            boxShadow: '0 2px 8px rgba(24,144,255,0.3)'
                          }}
                          onClick={handleEditInApp}
                        >
                          Edit in Desktop App
                        </Button>
                      </div>
                    </div>
                    <Divider style={{ margin: '32px 0', borderColor: '#d9d9d9' }} />
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(4, 1fr)',
                      gap: '24px'
                    }}>
                      <Card size="small" style={{ background: '#fff', border: '1px solid #f0f0f0', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
                        <div>
                          <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginBottom: 8 }}>Creator ID</Text>
                          <Text strong style={{ fontSize: '14px', color: '#262626' }}><strong>{doc.creator_id === userId ? userName : (doc.creator_id || 'N/A')}</strong></Text>
                        </div>
                      </Card>
                      <Card size="small" style={{ background: '#fff', border: '1px solid #f0f0f0', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
                        <div>
                          <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginBottom: 8 }}>Created Date</Text>
                          <Text strong style={{ fontSize: '14px', color: '#262626' }}>{formatDate(doc.created_at)}</Text>
                        </div>
                      </Card>
                      <Card size="small" style={{ background: '#fff', border: '1px solid #f0f0f0', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
                        <div>
                          <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginBottom: 8 }}>Last Edited</Text>
                          <Text strong style={{ fontSize: '14px', color: '#262626' }}>{formatDate(doc.updated_at)}</Text>
                        </div>
                      </Card>
                    </div>
                    {doc.description && (
                      <div style={{ marginTop: 24 }}>
                        <Card size="small" style={{ background: '#fff', border: '1px solid #f0f0f0' }}>
                          <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginBottom: 8 }}>Description</Text>
                          <Text style={{ fontSize: '14px' }}>{doc.description}</Text>
                        </Card>
                      </div>
                    )}
                    <div style={{ marginTop: 24 }}>
                      <Card size="small" style={{ background: '#fff', border: '1px solid #f0f0f0' }}>
                        <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginBottom: 8, textDecoration: 'underline' }}>
                          Additional Information
                        </Text>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                          <div>
                            <Text style={{ fontSize: '12px', color: '#8c8c8c' }}>Organization ID: </Text>
                            <Text style={{ fontSize: '12px' }}>{doc.organization_id || 'N/A'}</Text>
                          </div>
                          <div>
                            <Text style={{ fontSize: '12px', color: '#8c8c8c' }}>Media Format: </Text>
                            <Text style={{ fontSize: '12px' }}>{doc.media_format || 'N/A'}</Text>
                          </div>
                          <div>
                            <Text style={{ fontSize: '12px', color: '#8c8c8c' }}>MIME Type: </Text>
                            <Text style={{ fontSize: '12px' }}>{doc.media_mime_type || 'N/A'}</Text>
                          </div>
                          <div>
                            <Text style={{ fontSize: '12px', color: '#8c8c8c' }}>Public: </Text>
                            <Text style={{ fontSize: '12px' }}>{doc.is_public ? 'Yes' : 'No'}</Text>
                          </div>
                          <div>
                            <Text style={{ fontSize: '12px', color: '#8c8c8c' }}>Folder: </Text>
                            <Text style={{ fontSize: '12px' }}>{doc.is_folder ? 'Yes' : 'No'}</Text>
                          </div>
                          <div>
                            <Text style={{ fontSize: '12px', color: '#8c8c8c' }}>Indexed: </Text>
                            <Text style={{ fontSize: '12px' }}>{doc.is_indexed ? 'Yes' : 'No'}</Text>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </div>
                </Card>
              )}
            </Content>
          </>
        )}
      </Layout>
      {!documentTypeLoading && !(documentData?.document_type_name === "General" || doc?.document_type_name === "General") &&
        <Sider width={320} style={{ background: '#fff', borderLeft: '1px solid #f0f0f0', overflow: 'auto' }}>
          <div style={{ padding: 16 }}>
            <Title level={5} style={{ fontSize: 14, marginBottom: 12, color: '#262626' }}>Document Categories</Title>

            {isChildDocument() ? (
              // If current document is a child, show parent (Global Statement of Work)
              <DocumentPanel
                title="Global Statement of Work"
                icon="file"
                iconColor="#fa8c16"
                isExpanded={isSOWParentExpanded}
                setIsExpanded={setIsSOWParentExpanded}
                selectedItems={selectedSOWParent}
                handleChange={handleSOWParentChange}
                availableData={allSOWParentItems}
                category="sowParent"
                tagColor="orange"
                getItemById={getSOWParentItemById}
                handleRemoveTag={handleRemoveTag}
              />
            ) : isSOWDocument() ? (
              // If current document is SOW (parent), show all children
              <>
                <DocumentPanel
                  title="Global SOP - Key Stroke"
                  icon="global"
                  iconColor="#1890ff"
                  isExpanded={isGlobalSOPExpanded}
                  setIsExpanded={setIsGlobalSOPExpanded}
                  selectedItems={selectedGlobalSOP}
                  handleChange={handleGlobalSOPChange}
                  availableData={allGlobalSOPItems}
                  category="globalSOP"
                  tagColor="blue"
                  getItemById={getGlobalSOPItemById}
                  handleRemoveTag={handleRemoveTag}
                />
                <DocumentPanel
                  title="BP-Specific SOP - Key Stroke"
                  icon="gold"
                  iconColor="#722ed1"
                  isExpanded={isBPExpanded}
                  setIsExpanded={setIsBPExpanded}
                  selectedItems={selectedBPSpecific}
                  handleChange={handleBPSpecificChange}
                  availableData={allBPItems}
                  category="bpSpecific"
                  tagColor="purple"
                  getItemById={getBPItemById}
                  handleRemoveTag={handleRemoveTag}
                />
                <DocumentPanel
                  title="Annexures"
                  icon="paper-clip"
                  iconColor="#52c41a"
                  isExpanded={isAnnexuresExpanded}
                  setIsExpanded={setIsAnnexuresExpanded}
                  selectedItems={selectedAnnexures}
                  handleChange={handleAnnexuresChange}
                  availableData={allAnnexuresItems}
                  category="annexures"
                  tagColor="green"
                  getItemById={getAnnexuresItemById}
                  handleRemoveTag={handleRemoveTag}
                />

                <Title level={5} style={{ fontSize: 14, marginBottom: 12, marginTop: 24, color: '#262626' }}>Document Upload</Title>

                {/* Custom Work Instructions Panel - Single Select with Merge */}
                <div style={{ marginBottom: 16, border: '1px solid #d9d9d9', borderRadius: 4, overflow: 'hidden' }}>
                  <div
                    onClick={function () { setIsWorkInstructionsExpanded(!isWorkInstructionsExpanded); }}
                    style={{
                      padding: '12px 16px',
                      background: '#fafafa',
                      borderBottom: isWorkInstructionsExpanded ? '1px solid #d9d9d9' : 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      transition: 'all 0.3s'
                    }}
                  >
                    <span>
                      <Icon type="gold" style={{ color: '#722ed1', marginRight: 8 }} />
                      <Text strong style={{ fontSize: 12 }}>Work Instructions</Text>
                    </span>
                    <span>
                      {selectedMergeDocument && (
                        <Badge count={1} style={{ backgroundColor: '#722ed1', marginRight: 8 }} />
                      )}
                      <Icon
                        type={isWorkInstructionsExpanded ? "up" : "down"}
                        style={{ fontSize: 12, color: '#8c8c8c' }}
                      />
                    </span>
                  </div>
                  {isWorkInstructionsExpanded && (
                    <div style={{
                      padding: 16,
                      background: '#fff',
                      animation: 'slideDown 0.3s ease-out'
                    }}>
                      <Select
                        style={{ width: '100%', marginBottom: 12 }}
                        placeholder="Select a document to merge"
                        value={selectedMergeDocument}
                        onChange={handleWorkInstructionSelect}
                        allowClear
                        getPopupContainer={function (trigger) { return trigger.parentNode; }}
                        loading={loading}
                        showSearch
                        optionFilterProp="label"
                      >
                        {allWorkInstructionsItems.map(function (item) {
                          var displayText = item.title || item.filename;
                          return (
                            <Option key={item.id} value={item.id} label={displayText}>
                              <span style={{ fontSize: 11 }}>
                                {displayText}
                              </span>
                            </Option>
                          );
                        })}
                      </Select>
                      {selectedMergeDocument && (
                        <div style={{ marginTop: 12 }}>
                          <Button
                            type="primary"
                            icon="merge-cells"
                            block
                            loading={mergeLoading}
                            onClick={handleMergeDocument}
                            style={{ fontSize: 12 }}
                          >
                            Merge
                          </Button>
                        </div>
                      )}
                      {selectedMergeDocument && (
                        <div style={{ marginTop: 12 }}>
                          {(function () {
                            const item = getWorkInstructionsItemById(selectedMergeDocument);
                            return item ? (
                              <Tag
                                key={item.id}
                                closable
                                color="purple"
                                onClose={function () { setSelectedMergeDocument(null); }}
                                style={{ marginBottom: 8, marginRight: 8, fontSize: 11, display: 'inline-block', cursor: 'pointer' }}
                                onClick={function () {
                                  setEditor({
                                    editorParams: {
                                      documentName: item.title,
                                      documentId: item.path,
                                      userId: userId,
                                      userName: userName
                                    },
                                    isShowEditor: true
                                  });
                                  setShowMap(false);
                                }}
                              >
                                {item.title || item.filename}
                              </Tag>
                            ) : null;
                          })()}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </>
            ) : null}
          </div>
          <Divider style={{ margin: '16px 0' }} />
          <div style={{ padding: 16, background: '#fafafa' }}>
            <Title level={5} style={{ fontSize: 12, marginBottom: 12 }}>Document Hierarchy</Title>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Card size="small" bodyStyle={{ padding: 8 }}>
                <div><Icon type="file" style={{ color: '#fa8c16', marginRight: 8 }} /> <Text style={{ fontSize: 11 }}>Global Statement of Work</Text></div>
              </Card>
              <Card size="small" bodyStyle={{ padding: 8, background: '#f0f5ff' }}>
                <div><Icon type="global" style={{ color: '#1890ff', marginRight: 8 }} /> <Text style={{ fontSize: 11 }}>Global SOP - Key Stroke</Text></div>
              </Card>
              <Card size="small" bodyStyle={{ padding: 8, background: '#f0f5ff' }}>
                <div><Icon type="gold" style={{ color: '#722ed1', marginRight: 8 }} /> <Text style={{ fontSize: 11 }}>BP-Specific SOP - Key Stroke</Text></div>
              </Card>
              <Card size="small" bodyStyle={{ padding: 8, background: '#f0f5ff' }}>
                <div><Icon type="paper-clip" style={{ color: '#52c41a', marginRight: 8 }} /> <Text style={{ fontSize: 11 }}>Annexures</Text></div>
              </Card>
              <Card size="small" bodyStyle={{ padding: 8, background: '#f0f5ff' }}>
                <div><Icon type="gold" style={{ color: '#722ed1', marginRight: 8 }} /> <Text style={{ fontSize: 11 }}>Work Instructions</Text></div>
              </Card>
            </div>
          </div>
        </Sider>
      }
    </Layout>
  );
};

export default SOPModal;